import { render } from "./CloseIcon.vue?vue&type=template&id=904a53d0&ts=true"
import script from "./CloseIcon.vue?vue&type=script&lang=ts"
export * from "./CloseIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__